<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button icon="chevron-back-outline" [defaultHref]="defaultHref">
      </ion-back-button>
    </ion-buttons>

    <ion-title>
      <div class="logo" [class.logo--dev]="isDev">
        <div class="logo-text">dc3</div>
      </div>
      <span class="text-header">
        <ng-content></ng-content>
      </span>
    </ion-title>

    <ion-buttons slot="end" class="ion-padding-end header-buttons">
      <!--
      <ion-button *ngIf="statisticsRepository.currentStreak$ | async as streak"
                  routerLink="/stats"
                  routerLinkActive="button--active">
        <ion-icon [name]="streak.daysCount > 0 ? 'flash' : 'flash-outline'"
                  [color]="streak.todayIncluded ? 'success' : 'warning'">
        </ion-icon>
        {{ streak.daysCount }}
      </ion-button> -->

      <ion-button
        *ngIf="statisticsRepository.currentMonthlyStreak$ | async as streak"
        routerLink="/stats"
        routerLinkActive="button--active"
      >
        <ion-icon
          [name]="streak.days_count > 0 ? 'flash' : 'flash-outline'"
          [color]="streak.days_ratio > 0.1 ? 'success' : 'warning'"
        >
        </ion-icon>
        {{ streak.days_count }}/{{ streak.days_in_month }}
        {{ streak.month | date: "MMM" }}
      </ion-button>

      <!--      <div class="spacer"></div>-->

      <ion-button routerLink="/today" routerLinkActive="button--active">
        mein tag
      </ion-button>
      <!--      <ion-button routerLink="/min-writer"-->
      <!--                  routerLinkActive="button&#45;&#45;active">-->
      <!--        <ion-icon slot="icon-only" name="terminal-outline"></ion-icon>-->
      <!--      </ion-button>-->

      <!--      <ion-badge *ngIf="entryRepository.currentStreak$ | async as streak"-->
      <!--                 [color]="streak.todayIncluded ? 'success' : 'warning'">-->
      <!--        {{ streak.daysCount }}-->
      <!--      </ion-badge>-->

      <!--      <ion-button routerLink="/plan"-->
      <!--                  routerLinkActive="button&#45;&#45;active">-->
      <!--        planen-->
      <!--      </ion-button>-->

      <!--      <div class="spacer"></div>-->

      <!--      <ion-button routerLink="/understand"-->
      <!--                  routerLinkActive="button&#45;&#45;active">-->
      <!--        verstehen-->
      <!--      </ion-button>-->

      <ion-button routerLink="/topics" routerLinkActive="button--active">
        blog
      </ion-button>

      <!--      <div class="spacer"></div>-->

      <ion-button
        *ngIf="auth.user$ | async as user"
        (click)="showAccountPopover($event)"
      >
        <ion-icon name="person-circle-outline"></ion-icon>
      </ion-button>

      <!--  <ion-button>-->
      <!--    <ion-icon name="settings-outline"></ion-icon>-->
      <!--  </ion-button>-->
    </ion-buttons>
  </ion-toolbar>
</ion-header>
